import { inject, injectWithTransform, singleton } from "tsyringe";
import { AdsContext, Logger, LoggerTransformer } from "@identity/utils";
import { WINDOW } from "@identity/symbols";
import { CookieRepository } from "../TrackingContext";

@singleton()
export class CoppaSubject {
  coppaSubject: boolean;

  constructor(
    @inject(WINDOW) private window: Window,
    @injectWithTransform(Logger, LoggerTransformer, "CoppaSubject")
    private readonly logger: Logger,
    @inject(AdsContext) private readonly context: AdsContext,
    @inject(CookieRepository)
    private readonly cookieRepository: CookieRepository
  ) {
    this.createPartnersContext();
  }

  createPartnersContext() {
    if (!this.window.fandomContext || !this.window.fandomContext.partners) {
      this.window.fandomContext = {
        ...this.window.fandomContext,
        partners: {},
      };
    }
  }

  setIsCoppaSubjectInContext(isCoppaSubject: boolean): void {
    this.coppaSubject = isCoppaSubject;
    this.window.fandomContext.partners.directedAtChildren = isCoppaSubject;
    this.window.fandomContext.partners.blockthrough = {
      directedAtChildren: isCoppaSubject,
    };
  }

  isCoppaSubject(): boolean {
    if (this.coppaSubject === undefined) {
      return this.resolveCoppaStatus();
    }
    return this.coppaSubject;
  }

  resolveCoppaStatus(): boolean {
    const wikiDirectedAtChildren = Boolean(
      this.context.get()?.targeting?.directedAtChildren
    );

    if (!wikiDirectedAtChildren) {
      this.setIsCoppaSubjectInContext(false);
      return false;
    }

    try {
      const ageGateResult = this.cookieRepository.get("ag");
      const isCoppaSubject = ageGateResult !== "1";
      this.setIsCoppaSubjectInContext(isCoppaSubject);
      return isCoppaSubject;
    } catch (e) {
      this.logger.error("Error while reading age gate cookie");
    }
  }
}
